const PRIMARY_KEY = 'GENERAL_';

export const GENERAL_SECTION_MOCK_TESTS = PRIMARY_KEY + 'SECTION_MOCK_TESTS';
export const GENERAL_USER = PRIMARY_KEY + 'USER';
export const GENERAL_REVIEWABLE_QUESTION = PRIMARY_KEY + 'REVIEWABLE_QUESTION';
export const GENERAL_FACULITY_MOCKTEST_SOLUTION_MARKS =
   PRIMARY_KEY + 'FACULITY_MOCKTEST_SOLUTION_MARKS';
